<form class="reports-group-search-container" (ngSubmit)="find()" autocomplete="off">
    <div class="title-name">
        <label for="name">{{nameLabel}}</label>        
    </div>
    <div class="filter-name">
        <input class="form-control" type="text" name="txtName"  disabled="{{disableName}}" id="txtName" [(ngModel)]="name" maxlength="50"/>
    </div>
    <div class="title-id">
        <label for="id">{{idLabel}}</label>
    </div>
    <div class="filter-id">                
        <input class="form-control" type="text" name="txtId" disabled="{{disableId}}" id="txtId" [(ngModel)]="id" maxlength="12" required="false" pattern="^\w{4,12}$">                 
    </div>
    <div class="search-group-button">
        <button id="btnSearch" class="btn btn-primary" type="submit">
            {{searchLabel}}
        </button>
    </div>
</form>
